import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	selectedPlan: null,
	billingType: 'monthly',
};

const subscriptionSlice = createSlice({
	name: 'subscription',
	initialState,
	reducers: {
		setPlan: (state, action) => {
			const { id, title, monthlyPrice, yearlyPrice, billing } = action.payload;

			state.selectedPlan = {
				id,
				title,
				monthlyPrice,
				yearlyPrice,
				billing,
				price: billing === 'monthly' ? monthlyPrice : yearlyPrice,
			};

			state.billingType = billing;
		},

		setBillingType: (state, action) => {
			state.billingType = action.payload;

			if (state.selectedPlan) {
				state.selectedPlan.billing = action.payload;

				state.selectedPlan.price =
					action.payload === 'monthly'
						? state.selectedPlan.monthlyPrice
						: state.selectedPlan.yearlyPrice;
			}
		},

		clearSubscription: (state) => {
			state.selectedPlan = null;
			state.billingType = 'monthly';
		},
	},
});

export const { setPlan, setBillingType, clearSubscription } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
